
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getVerifyOtpDtoFormGroup() {
return new FormGroup({
    otp: new FormControl<string | undefined>('', [Validators.required]),
    appAccessCode: new FormControl<string | undefined>(''),
    mailId: new FormControl<number | undefined>(undefined),
    phoneId: new FormControl<number | undefined>(undefined),
    mobileNumber: new FormControl<string | undefined>(''),
})
;
}
      